var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('text-form-group',{attrs:{"value":_vm.value.list_reference,"name":"list_reference","label":"List Reference","error":(_vm.errors.list_reference || [])[0]},on:{"input":function($event){return _vm.input('list_reference', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }